
import {
  Box,
  Flex,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import DatePickerButton from './DatePickerButton';
import { Button } from 'barte-design-system';
import { Select } from '@/components';

export interface FilterOption {
  value: string;
  label: string;
}

export interface PaymentFilterProps {
  // Campo de busca
  searchTerm: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  // Filtro de status
  statusFilter: string;
  onStatusChange: (value: string) => void;
  statusOptions: FilterOption[];
  // Filtro de centro de custo
  costCenterFilter: string;
  onCostCenterChange: (value: string) => void;
  costCenterOptions: FilterOption[];
  // Filtros de data
  startDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  endDate: Date | null;
  onEndDateChange: (date: Date | null) => void;
  onClearDateFilters: () => void;
  // Opções de layout
  columns?: { base?: number; md?: number; lg?: number };
  spacing?: number;
}

export function PaymentFilter({
  searchTerm,
  onSearchChange,
  searchPlaceholder = "Buscar por chave PIX, beneficiário...",
  statusFilter,
  onStatusChange,
  statusOptions,
  costCenterFilter,
  onCostCenterChange,
  costCenterOptions,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  onClearDateFilters,
  columns = { base: 1, md: 2, lg: 5 },
  spacing = 4,
}: PaymentFilterProps) {
  return (
    <Box p={4} bg="white.50" borderRadius="lg" borderColor="white.200">
      <SimpleGrid columns={columns} spacing={spacing}>
        <Box>
          <FormLabel htmlFor="search" fontSize="sm" fontWeight="semibold" color="gray.700">
            Buscar
          </FormLabel>
          <InputGroup>
            <InputLeftElement>
              <SearchIcon color="gray.400" boxSize={4} />
            </InputLeftElement>
            <Input
              name="search"
              id="search"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              pl={10}
              fontSize="sm"
              borderRadius="6px"
              _focus={{ borderColor: "black" }}
            />
          </InputGroup>
        </Box>

        {/* Filtro de Status */}
        <Box>
          <FormLabel htmlFor="status-filter" fontSize="sm" fontWeight="semibold" color="gray.700">
            Status
          </FormLabel>
          <Select
            name="statusFilter"
            label=""
            defaultValue={statusFilter}
            optionsList={statusOptions.map((option) => ({
              title: option.label,
              value: option.value
            }))}
            onChange={(e) => onStatusChange(e.target.value)}
          />
        </Box>

        {/* Filtro de Centro de Custo */}
        <Box>
          <FormLabel htmlFor="costcenter-filter" fontSize="sm" fontWeight="semibold" color="gray.700">
            Centro de Custo
          </FormLabel>
          <Select
            name="costCenterFilter"
            label=""
            defaultValue={costCenterFilter}
            optionsList={[
              { title: "Todos os centros", value: "all" },
              ...costCenterOptions.map((center) => ({
                title: center.label,
                value: center.value
              }))
            ]}
            onChange={(e) => onCostCenterChange(e.target.value)}
          />
        </Box>
        <DatePickerButton
          label="Data Inicial"
          date={startDate}
          onSelect={onStartDateChange}
          maxDate={endDate || undefined}
        />
        <DatePickerButton
          label="Data Final"
          date={endDate}
          onSelect={onEndDateChange}
          minDate={startDate || undefined}
        />
      </SimpleGrid>
      
      {(startDate || endDate) && (
        <Flex justify="flex-end" mt={2}>
          <Button size="sm" variant="link" onClick={onClearDateFilters}>
            Limpar filtros de data
          </Button>
        </Flex>
      )}
    </Box>
  );
}

export default PaymentFilter;